export default "__VITE_ASSET__B$ml5T_7__"